const styles = (theme) => {
    return {
        kolibries: {
            width: 600,
        },

        kolibries__icon: {
            color: theme.palette.text.secondary,
        },
    };
};

export default styles;
